import * as React from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
  GridToolbar,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "../../css/cimplist.css";
import { Button, Divider, Paper } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import moment from "moment/moment";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const columns = [
  {
    field: "carrierCode",
    headerName: "CARRIER",
    width: 110,
    headerClassName: "sub3-app-theme--header",
    cellClassName: "super3-app-theme--cell",
  },
  {
    field: "fwbCount",
    headerName: "FWB COUNT",
    width: 150,
    headerClassName: "sub-app-theme--header",
    cellClassName: "super-app-theme--cell",
  },
  {
    field: "fwbSize",
    headerName: "FWB DATASIZE(BYTE)",
    width: 150,
    headerClassName: "sub-app-theme--header",
    cellClassName: "super-app-theme--cell",
  },
  {
    field: "ffmCount",
    headerName: "FFM COUNT",
    width: 150,

    headerClassName: "sub2-app-theme--header",
    cellClassName: "super2-app-theme--cell",
  },
  {
    field: "ffmSize",
    headerName: "FFM DATASIZE(BYTE)",
    width: 150,
    headerClassName: "sub2-app-theme--header",
    cellClassName: "super2-app-theme--cell",
  },
  {
    field: "fhlCount",
    headerName: "FHL COUNT",
    width: 150,

    headerClassName: "sub-app-theme--header",
    cellClassName: "super-app-theme--cell",
  },
  {
    field: "fhlSize",
    headerName: "FHL DATASIZE(BYTE)",
    width: 150,
    headerClassName: "sub-app-theme--header",
    cellClassName: "super-app-theme--cell",
  },
  {
    field: "fsuCount",
    headerName: "FSU COUNT",
    width: 150,
    headerClassName: "sub2-app-theme--header",
    cellClassName: "super2-app-theme--cell",
  },
  {
    field: "fsuSize",
    headerName: "FSU DATASIZE(BYTE)",
    width: 150,
    headerClassName: "sub2-app-theme--header",
    cellClassName: "super2-app-theme--cell",
  },
  {
    field: "totalCount",
    headerName: "TOTAL COUNT",
    width: 150,
    headerClassName: "sub-app-theme--header",
    cellClassName: "super-app-theme--cell",
  },
  {
    field: "totalSize",
    headerName: "TOTAL DATASIZE(K BYTE)",
    width: 180,
    headerClassName: "sub-app-theme--header",
    cellClassName: "super-app-theme--cell",
  },
];

const columnGroupingModel = [
  {
    groupId: "FWB",
    children: [{ field: "fwbCount" }, { field: "fwbSize" }],
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
  },
  {
    groupId: "FFM",
    children: [{ field: "ffmCount" }, { field: "ffmSize" }],
    headerAlign: "center",
    headerClassName: "super2-app-theme--header",
  },

  {
    groupId: "FHL",
    children: [{ field: "fhlCount" }, { field: "fhlSize" }],
    headerAlign: "center",
    headerClassName: "super3-app-theme--header",
  },

  {
    groupId: "FSU",
    children: [{ field: "fsuCount" }, { field: "fsuSize" }],
    headerAlign: "center",
    headerClassName: "super4-app-theme--header",
  },
  {
    groupId: "TOTAL",
    children: [{ field: "totalCount" }, { field: "totalSize" }],
    headerAlign: "center",
    headerClassName: "super5-app-theme--header",
  },
];

export default function ListMain() {
  const apiUrl = process.env.REACT_APP_APISITA;
  const [end, setEnd] = React.useState();
  const [start, setStart] = React.useState(null);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const changeStart = (value) => {
    setStart(value);
    setStartDate(moment(new Date(value)).format("YYYY-MM-DD"));
  };
  const changeEnd = (value) => {
    setEnd(value);
    setEndDate(moment(new Date(value)).format("YYYY-MM-DD"));
  };
  const [filterModel, setFilterModel] = React.useState({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [],
  });
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});

  const test = () => {
    setRows([]);
    fetch(`${apiUrl}/sita/status?start=${startDate}&end=${endDate}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }
        return response.json();
      })
      .then((res) => {
        if (res.length === 0) {
          alert("NO DATA");
        } else {
          setData(res);
          setRows(
            res.map((row, index) => ({
              id: index,
              carrierCode: row.carrierCode,
              ffmCount: row.ffmCount,
              ffmSize: row.ffmSize,
              fhlCount: row.fhlCount,
              fhlSize: row.fhlSize,
              fwbCount: row.fwbCount,
              fwbSize: row.fwbSize,
              fsuCount: row.fsuCount,
              fsuSize: row.fsuSize,
              totalCount:
                row.ffmCount + row.fhlCount + row.fwbCount + row.fsuCount,
              totalSize: (
                (row.ffmSize + row.fhlSize + row.fwbSize + row.fsuSize) /
                1024
              ).toFixed(0),
            }))
          );
        }
      })
      .catch((error) => console.error("Error:", error));
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "800px",
      }}
    >
      <Box
        sx={{
          height: 60,
          mt: "auto",
          mb: 3,
          display: "flex",
          justifyContent: "center",
          borderBottom: "2px solid #d3d3d3",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer
            sx={{ width: "200px", marginLeft: 90 }}
            components={["DatePicker"]}
          >
            <DatePicker
              sx={{
                width: "50%",
              }}
              label="START"
              slotProps={{ textField: { size: "small" } }}
              value={start}
              onChange={(value) => changeStart(value)}
            />
          </DemoContainer>
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer sx={{ width: "200px" }} components={["DatePicker"]}>
            <DatePicker
              sx={{ width: "50%" }}
              label="END"
              slotProps={{ textField: { size: "small" } }}
              value={end}
              onChange={(value) => changeEnd(value)}
            />
          </DemoContainer>
        </LocalizationProvider>

        <Button
          sx={{ margin: "auto", marginLeft: 1 }}
          variant="contained"
          size="medium"
          onClick={(e) => {
            e.stopPropagation();
            test();
          }}
        >
          조회
        </Button>
      </Box>
      <Box sx={{ height: 700 }}>
        <DataGrid
          experimentalFeatures={{ columnGrouping: true }}
          columns={columns}
          rows={rows}
          disableColumnFilter
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25 },
            },
          }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          columnGroupingModel={columnGroupingModel}
          rowHeight={30}
          columnHeaderHeight={40}
          sx={{ width: "90%", ml: 12, background: "#ffffff" }}
        />
      </Box>
    </Box>
  );
}
